import React, { useEffect } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import Layout from "../../molecules/Layout";
import "./About.css";
import HouseImg from "../../../assets/images/image1.png";
import BANNER02 from "../../../assets/images/image2.png";
import BANNER03 from "../../../assets/images/image3.png";
import BANNER04 from "../../../assets/images/image4.png";
import { useLocation } from "react-router-dom";

const images = {
  welcome: BANNER03,
  whatWeOffer: BANNER04,
  buyersSellers: BANNER02,
  technology: HouseImg,
};

const Aboutus = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);
  return (
    <Layout>
      <main className="about-container">
        <h1 className="about-title">About Next Door Auctions</h1>
        <WelcomeSection />
        <WhatWeOfferSection />
        <BuyersSellersSection />
        <TechnologySection />
        <ExpertTeamSection />
        <EffortlessUserExperienceSection />
        <WhyChooseUsSection />
      </main>
    </Layout>
  );
};

const WelcomeSection = () => {
  return (
    <section className="about-section flex-column">
      <div className="about-content">
        <h2 className="about-section-title">Welcome to Next Door Auctions</h2>
        <p className="about-text">
          Next Door Auctions is a leading online platform specializing in real
          estate auctions nationwide. Whether you're a seasoned investor or a
          first-time homebuyer, our Next Door Auctions platform delivers a
          seamless and transparent way to access exclusive property deals.
        </p>
      </div>
      <div className="about-image-wrapper">
        <LazyLoadImage
          src={images.welcome}
          alt="Welcome to Next Door Auctions"
          effect="blur"
          className="about-image"
        />
      </div>
    </section>
  );
};

const WhatWeOfferSection = () => {
  return (
    <section className="about-section about-section-reverse flex-column">
      <div className="about-content">
        <h2 className="about-section-title">What We Offer</h2>
        <p className="about-text">
          We specialize in auctioning properties-nationwidewhere opportunities
          for investment, development, or personal use are both unique and
          cost-effective. Our inventory is refreshed weekly, ensuring buyers
          have ongoing access to new properties and opportunities.
        </p>
      </div>
    </section>
  );
};

const BuyersSellersSection = () => {
  return (
    <section className="about-section">
      <div className="about-content">
        <h2 className="about-section-title">
          Meeting The Needs Of Buyers And Sellers
        </h2>
        <div className="about-text">
          <li className="font-semibold mb-2">For buyers</li>
          <p className="mb-2">Our buyers benefit from:</p>

          <ul className="about-list" style={{ marginLeft: "18px" }}>
            <li>Real-time access to exclusive property listings</li>
            <li>Comprehensive property information and documentation</li>
            <li>Personalized alerts and property matching tools</li>
            <li>
              Educational resources and customer support throughout the process
              Visit our FAQs to learn more about the auction process.
            </li>
            {/* <li>Next our TAGs to learn more about the auction process.</li> */}
          </ul>
          <li className="font-semibold mt-4 mb-2">Sellers</li>
          <p className="mb-2">Our sellers receive:</p>
          <ul className="about-list" style={{ marginLeft: "18px" }}>
            <li>
              Access to one of the nation's most trusted and effective auction
              programs
            </li>
            <li>Industry-leading marketing reach and asset visibility</li>
            <li>
              Data insights and analytics to accelerate asset disposition Our
              platform uses mobile and digital technology to maximize exposure
              and transaction speed.
            </li>
          </ul>
          {/* <p className="mt-4">
            Our platform uses mobile and digital technology to maximize exposure
            and transaction speed.
          </p> */}
        </div>
      </div>
      <div className="about-image-wrapper">
        <LazyLoadImage
          src={images.buyersSellers}
          alt="Meeting The Needs Of Buyers And Sellers"
          effect="blur"
          className="about-image"
        />
      </div>
    </section>
  );
};

const TechnologySection = () => {
  return (
    <section className="about-section about-section-reverse flex-column">
      <div className="about-content">
        <h2 className="about-section-title">Technology-Driven Bidding</h2>
        <p className="about-text">
          Powered by innovative technology, Next Door Auctions offers a secure,
          user-friendly environment for online bidding. The platform includes
          real-time updates, comprehensive property details, high-resolution
          photos, and essential documentation—all designed to empower confident
          decision-making from any device, anytime.
        </p>
      </div>
    </section>
  );
};

const ExpertTeamSection = () => {
  return (
    <section className="about-section">
      <div className="about-content">
        <h2 className="about-section-title">Expert Team</h2>
        <p className="about-text">
          Our team consists of licensed auctioneers and experienced real estate
          professionals dedicated to maintaining a transparent and legally
          compliant transaction process. With decades of combined experience, we
          bring integrity and industry knowledge to every auction. Our team is
          entirely US based, in all US time zones.
        </p>
      </div>
      <div className="about-image-wrapper">
        <LazyLoadImage
          src={images.whatWeOffer}
          alt="What We Offer"
          effect="blur"
          className="about-image"
        />
      </div>
    </section>
  );
};

const EffortlessUserExperienceSection = () => {
  return (
    <section className="about-section about-section-reverse">
      <div className="about-content">
        <h2 className="about-section-title">Effortless User Experience</h2>
        <p className="about-text">
          Our user-friendly website is designed to provide an effortless
          browsing and bidding experience. Whether you’re looking to buy your
          first home or expand your investment portfolio, Next Door Auctions
          makes it easy to find and acquire properties that suit your needs and
          budget.
        </p>
      </div>
      <div className="about-image-wrapper">
        <LazyLoadImage
          src={images.technology}
          alt="Technology-Driven Bidding"
          effect="blur"
          className="about-image"
        />
      </div>
    </section>
  );
};

const WhyChooseUsSection = () => {
  return (
    <section className="about-section flex-column">
      <div className="about-content">
        <h2 className="about-section-title">Why Choose Us</h2>
        <p className="about-text">
          Join thousands of satisfied buyers and sellers who trust Next Door
          Auctions for an efficient and rewarding property auction experience.
          With a focus on technology, and unmatched service, Next Door Auctions
          is redefining how real estate is bought and sold online.
        </p>
      </div>
    </section>
  );
};

export default Aboutus;
